import React, { useRef } from 'react';
import Button from '@mui/material/Button';


function CreatingInvoice(props) {

  const amountRef = useRef(null);
  const senderRef = useRef(null);
  const messageRef = useRef(null);
  const numberRef = useRef(null);

  const handleClick = () =>{
    event.preventDefault();
    const amount = amountRef.current.value;
    const sender = senderRef.current.value;
    const message = messageRef.current.value;
    const number = numberRef.current.value;
    
    props.handleClick({amount,sender,message,number})
  }
  return (

    <div>
    <h1 className="ml-4 mr-4 mb-4 text-center text-lg dark:text-jacarta-200 font-bold">
      30초만에 비트코인 기프트콘 만들기 👇️
    </h1>

    <div>
      
    </div>
    <div className=" dark:border-jacarta-600 border-jacarta-100 border bg-white p-8">
      <span className="flex items-center mb-4">
        <input ref={amountRef} className="focus:ring-accent h-10 w-full flex-[3] border-jacarta-200 focus:ring-inse dark:text-jacarta-700" placeholder="선물할 비트코인 (satoshi)" min="10" type="number" id="amount">
        </input>
        <div className="h-10 border border-jacarta-200 flex items-center">
          <span className="ml-2 mr-2 text-sm text-jacarta-400">sats</span>
        </div>
      </span>

      <span className="flex items-cente mb-4">
      <input ref={senderRef} className="focus:ring-accent h-10 w-full flex-[3] border-jacarta-200 focus:ring-inse dark:text-jacarta-700" placeholder="보내는 사람" type="text">
      </input>
      </span>

      <span className="flex items-center mb-4">
      <input ref={messageRef} className="focus:ring-accent h-10 w-full flex-[3] border-jacarta-200 focus:ring-inse dark:text-jacarta-700" placeholder="메시지 남기기" type="text">
      </input>
      </span>

      <span className="flex items-center">
      <input ref={numberRef} className="focus:ring-accent h-10 w-full flex-[3] border-jacarta-200 focus:ring-inse dark:text-jacarta-700" placeholder="기프트콘 개수" type="number">
      </input>
      </span>      

      <div style={{display: 'flex', alignItems: 'center'}}>
        <Button
          fullWidth style={{marginTop:'10px', backgroundColor: '#F7931A', color: '#fff'}} variant="contained"
          onClick={e=>handleClick(e)}
        >발행하기</Button>
      </div>
    </div>
    </div>


  );
}

export default CreatingInvoice;
